import React from 'react';
export function Temoignage() {
  return <section className="bg-sage-deep text-ivory" data-id="element-108" data-mp="75psnw6ne97v">
      <div className="mx-auto grid max-w-page items-center gap-12 px-6 py-20 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:py-24" data-id="element-109" data-mp="20uqkb1h649pd">
        <figure className="lg:col-span-7" data-id="element-110" data-mp="2fjwicm49rtvo">
          <blockquote className="font-serif text-2xl font-light leading-[1.35] sm:text-[2.1rem]" data-id="element-111" data-mp="2fkxw4yco6uh3">
            « J’arrivais avec un dos bloqué depuis des mois. Christine ne m’a pas demandé d’aller plus loin,
            elle m’a appris à aller mieux. Un an après, je ne pense plus à mon dos. »
          </blockquote>
          <figcaption className="mt-7 text-sm text-ivory/70" data-id="element-112" data-mp="2yhpactdcujea">
            Hélène M. — <span className="text-ivory/50" data-id="element-113" data-mp="2yfwabwx8yxf9">élève en Pilates et stretching postural</span>
          </figcaption>
        </figure>

        <div className="lg:col-span-5" data-id="element-114" data-mp="143of0ih0keiy">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/24cfaf5a-ec24-4caf-ac09-27d3835bc423.jpg" alt="Détail des mains posées sur un tapis pendant une séance" className="aspect-[16/9] w-full object-cover" data-id="element-115" data-mp="144hmjlnsr825" />
        </div>
      </div>
    </section>;
}